// Meta (Facebook) Pixel — loaded ONLY after the visitor accepts marketing
// cookies. Nothing here runs until consent is granted (see consent.js).

import { hasAnalyticsConsent, onConsentChange } from './consent';

export const PIXEL_ID = '2572748436485922';

let loaded = false;
let subscribed = false;

// Inject the standard Meta Pixel base code + init. Called only on consent.
const injectPixel = () => {
  if (window.fbq) return;
  /* eslint-disable prefer-rest-params */
  const n = function () {
    if (n.callMethod) {
      n.callMethod.apply(n, arguments);
    } else {
      n.queue.push(arguments);
    }
  };
  /* eslint-enable prefer-rest-params */
  window.fbq = n;
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  if (s && s.parentNode) s.parentNode.insertBefore(t, s);
  window.fbq('init', PIXEL_ID);
};

// Safe event tracker — no-ops unless the pixel is present AND consent is given.
export const trackEvent = (name, params) => {
  if (!window.fbq || !hasAnalyticsConsent()) return;
  try {
    if (params) window.fbq('track', name, params);
    else window.fbq('track', name);
  } catch (e) {
    /* no-op: never let analytics break the app */
  }
};

export const trackPageView = () => trackEvent('PageView');

// Load the pixel if the visitor has consented. Fires an initial PageView.
export const loadPixel = () => {
  if (loaded || !hasAnalyticsConsent()) return;
  loaded = true;
  injectPixel();
  trackPageView();
};

// Call once on app start: load now if already consented, and auto-load the
// moment consent is granted via the banner.
export const initPixel = () => {
  loadPixel();
  if (!subscribed) {
    subscribed = true;
    onConsentChange((v) => {
      if (v === 'accepted') loadPixel();
    });
  }
};
